import React, { Component } from "react";

import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardImage,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
  Button,
} from "mdbreact";
import { Card, CardHeader } from "reactstrap";
import BreadCumb from "../Department/BreadCumb";
import { PostData } from "../../api/service";
import { Container, Typography } from "@material-ui/core";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";

// const facultyData = [
//     {
//         name: 'Dr. Jogesh Kakati',
//         desg: 'Principal',
//         qualification: 'MA, PhD',
//         email: '',
//         phone: '',
//         mobile: '',
//         specifications: '',
//         cv: '',
//         photo: ''
//     },

// ]

export default class PrincipalContainer extends Component {
  state = {
    facultyData: [],
    isLoaded: false,
    dept_code: "OFF",
  };

  componentDidMount() {
    let d = {
      dept_code: "OFF",
      type: "PRINCIPAL",
    };

    PostData(`/getemployeebytype`, d).then((resp) => {
      //console.log(resp)
      this.setState({
        ...resp[0],
        facultyData: resp,
        isLoaded: true,
      });
    });
  }
  render() {
    return (
      <div>
        <BreadCrumbOwn title="Principal's Message" />

        <Container className="mb-5">
          <br />

          {this.state.isLoaded &&
            this.state.facultyData.map((el, index) => {
              return (
                <div>
                  {/* <Card style={{ boxShadow: 'none' }}>
                            <CardHeader style={{ color: 'white', boxShadow: 'none', backgroundColor: '#1E3760', textAlign: 'center' }}> <h3 style={{color: 'inherit'}}>{el.desg}</h3></CardHeader>
                        </Card> */}

                  <div>
                  <div>
                        <div style={{ textAlign: "left" }}>
                          <img
                            alt=""
                            src={el.dp.length > 0 ? el.dp[0] : ""}
                            // src={require("./image/principal.jpg")}
                            style={{
                              width: "350px",
                              boxShadow: "1px 2px 10px rgba(0,0,0,0.1)",
                              border: `solid 5px wheat`,
                            }}
                          />
                        </div>

                        {/* <h5
                          style={{
                            fontSize: "16px",
                            textAlign: "right",
                            fontWeight: 700,
                          }}
                        >
                          {el.name}<br />
                          Internship and Apprenticeship cell, Dispur College .<br />
						               Eraligool, Sribhumi
                        </h5> */}
                       
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`mailto:${el.email}`}>{el.email}</a>
                        </h6>
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`tel:${el.phone}`}>{el.phone}</a>
                        </h6>
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`tel:${el.mobile}`}>{el.mobile}</a>
                        </h6>
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          {/* <a href={`tel:${el.mobile}`}>
                            {this.state.isLoaded && this.state.id != undefined && (
                              <a
                                style={{
                                  color: "#1892FF",
                                  cursor: "pointer",
                                  fontWeight: 700,
                                  textAlign: "right",
                                }}
                                // href={`/department/${this.state.dept_code}/faculty/single?id=${this.state.id}&name=${this.state.name}`}
                                href={el.cv.length > 0 ? el.cv[0] : ""}
                              >
                                Visit Profile
                              </a>
                            )}
                          </a> */}
                        </h6>
                      </div>
                    <div>
                      <Typography
                        variant="h5"
                        style={{ margin: "1em 0", fontWeight: 700 }}
                        gutterBottom
                      >
                        WELCOME MESSAGE FROM THE PRINCIPAL
                      </Typography>
                      <Typography
                        style={{ textAlign: "justify" }}
                        variant="body1"
                        gutterBottom
                      >
                        Dear Students,

I would like to take this opportunity to heartily invite each one of you, who desires to gain knowledge and be an asset to the society and the nation to the premises of Dispur College. The College named under the capital of Assam has produced many eminent figures and we are still in the journey to continue producing many more eminent personalities who can make the state and the nation proud. As A.P.J. Abdul Kalam said “Every youth is Unique” we at Dispur College, aim to achieve holistic development of each and every student, so that tomorrow they can stand at their own feet and explore new ventures that await for them at every juncture of their life. As we all are aware of the fact that, an institution cannot shine only with the efforts of one person, so I humbly invite all of you to the process of taking the College to the pinnacle of success. The college shall forever look to address many grievances that a student might face in their journey of education and henceforth would try to implement as many apt and necessary steps as required, so that when they leave the institution they carry forth an individual identity of their own.The folk culture of the region in the form of art, dance, and creative writings has been made an integral part of campus life for the students. It would go a long way in preserving traditions and cultural ethos of this progressive state.
I therefore want to take the privilege to invite all of you to be a part of this prestigious institution and in the process unleash a new version of yourself.
As Rabindranath Tagore wrote, "Where the mind is without fear and knowledge is held high", the college shall forever uphold this motto and shall ignite the young minds to be the future stars of our Nation building process.


                      </Typography>

                      <br />

                      {/* <Typography
                        style={{ textAlign: "justify" }}
                        variant="body1"
                        gutterBottom
                      >
                        The Mahavidyalaya commenced its maiden academic journey from the academic session 2017-2018, offering Higher Secondary (10+2) courses in Science under Assam Higher Secondary Education Council, Bamunimaidam, Guwahati, and Under-graduate (UG) Science programmes leading to Bachelor of Science (B.Sc.) under Assam University, Silchar. Now, the Mahavidyalaya has emerged as a truly multidisciplinary higher education institution by offering Four-Year Under-graduate (FYUG) Programmes in both Arts and Science streams based on the NEP 2020 curriculum, under Assam University, Silchar, from the academic session 2023-2024. While the FYUG Programmes in Science are offered in six subjects, such as Physics, Chemistry, Mathematics, Botany, Zoology, Statistics; the FYUG Programmes in Arts are offered in seven subjects that include English, Bengali, Economics, Education, Sociology, Political Science, and History. It is to be mentioned here that the FYUG Programmes in Arts were introduced at the Mahavidyalaya from the academic session 2023-2024.
                      </Typography> */}

                      {/* <br/>
                      <Typography
                        style={{ textAlign: "justify" }}
                        variant="body1"
                        gutterBottom
                      >In order to provide high-quality Arts and Science education at the UG level, the Mahavidyalaya has an appropriate infrastructure in place, including academic buildings and laboratories. Various workshops focusing on different aspects of Arts and Science education and research, as well as numerous co-curricular activities, are regularly organized on the days of national significance. The Mahavidyalaya has successfully completed infrastructure projects such as the construction of girls’ hostel, boundary walls, and residential complexes for Staff and Sports buildings. Plans are underway to establish a gymnasium for the fitness needs of both the students and employees. Further infrastructure development includes the construction of a Canteen and an academic annex building. The Mahavidyalaya is currently making preparations for the first cycle of visit by the National Assessment and Accreditation Council (NAAC) during the current academic session.</Typography>
                      <br /> */}
                      {/* <Typography
                        style={{ textAlign: "justify" }}
                        variant="body1"
                        gutterBottom
                      >I express my gratitude to the Hon’ble the then District Commissioner, Sribhumi cum Founder President, Governing Body of our Mahavidyalaya, Mr. P. K. Talukdar , ACS, for allocating an additional five bighas of land for the Mahavidyalaya's playground. DISPUR, Eraligool is dedicated to providing skill-based knowledge, fostering inclusive education, promoting participatory culture, and instilling a value-oriented approach alongside its regular courses, aligning with the NEP 2020 of the Government of India. The Mahavidyalaya is committed to advancing its academic dimensions through high-quality teaching, innovative pedagogical techniques, and research to cater to the requirements of Arts and Science education. It is with great privilege that I announce the presence of well-qualified, experienced, and enthusiastic teachers who are devoted to their vocation. This educational institution will be instrumental in enabling students to attain academic and intellectual achievements.</Typography>


                      <br /> */}

                      

                      <div>
                        {/* <div style={{ textAlign: "right" }}>
                          <img
                            alt=""
                            src={el.dp.length > 0 ? el.dp[0] : ""}
                            style={{
                              width: "250px",
                              boxShadow: "1px 2px 10px rgba(0,0,0,0.1)",
                              border: `solid 5px wheat`,
                            }}
                          />
                        </div> */}

                        <h4
                          style={{
                            fontSize: "20px",
                            textAlign: "right",
                            fontWeight: 700,
                          }}
                        >
                          Dr. Navajyoti Borah<br />
                          Dispur College<br />
						               Dispur, Guwhati
                        </h4>
                       
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`mailto:${el.email}`}>{el.email}</a>
                        </h6>
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`tel:${el.phone}`}>{el.phone}</a>
                        </h6>
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`tel:${el.mobile}`}>{el.mobile}</a>
                        </h6>
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          {/* <a href={`tel:${el.mobile}`}>
                            {this.state.isLoaded && this.state.id != undefined && (
                              <a
                                style={{
                                  color: "#1892FF",
                                  cursor: "pointer",
                                  fontWeight: 700,
                                  textAlign: "right",
                                }}
                                // href={`/department/${this.state.dept_code}/faculty/single?id=${this.state.id}&name=${this.state.name}`}
                                href={el.cv.length > 0 ? el.cv[0] : ""}
                              >
                                Visit Profile
                              </a>
                            )}
                          </a> */}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </Container>
      </div>
    );
  }
}
